import * as api from "backoffice-api"
import { API_TOKEN, BACKOFFICE_API_URL } from "../env"

export const initializeBackofficeApi = () => {
  api.initializeBackofficeApi({
    apiBaseUrl: BACKOFFICE_API_URL,
    apiToken: API_TOKEN,
  })
}
